var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RouterView',{key:_vm.$route.meta.type,attrs:{"globalError":_vm.globalError}})
}
var staticRenderFns = []

export { render, staticRenderFns }